import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  constructor(
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  getWindow(): Window | null {
    return this._doc.defaultView;
  }

  getLocation(): Location {
    return this._doc.location;
  }

  createElement(tag: string): HTMLElement {
    return this._doc.createElement(tag);
  }

  createCookie(key: string, value: any, days: number, domain: string = '') {
    try {
      let expires, finalDomain;
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
      } else {
        expires = '';
      }
      if (domain !== '') {
        finalDomain = `;domain=${domain}`;
      } else {
        finalDomain = '';
      }

      const setValue =
        typeof value === 'object' ? JSON.stringify(value) : value;
      this._doc.cookie = `${key}=${setValue}${expires}${finalDomain};path=/`;
    } catch (err) {
      console.error('Cookies have been disabled.');
    }
  }

  /**
   * Temporary themeMode solution for M2 launch.
   * FIXME:TODO: toss this into the dumpster where it belongs and make themeMode a global state
   */
  handleThemeMode() {
    // document only exists on browser
    if (isPlatformBrowser(this.platformId)) {
      const cookies = document?.cookie.split('; ');
      return (
        cookies
          .find((cookie) => cookie === 'avythmmde=industrial')
          ?.split('=')[1] || 'default'
      );
    } else {
      return 'default';
    }
  }
}
